import { UserModel } from '@core/model/user.model';
//import { FilterByFamily } from '@core/model/FilterByFamily.model';
import { from } from 'rxjs';
import { CutsProjectModel } from '@core/model/custProject.model';

export class utiles {
  constructor() {}

  /************************LIMPIEZA DEL CACHE*********************/
  //#region clean Storage
  static clearAllCache() {
    this.clearCacheUser();
  }

  static clearCacheUser() {
    localStorage.removeItem('cacheUser');
    localStorage.removeItem('password');
    localStorage.removeItem('authorizationClient');
    localStorage.removeItem('cacheSelectedFamily');
    localStorage.removeItem('cacheSelectedAddress');
    localStorage.removeItem('cacheSelectedFamily');
    localStorage.removeItem('cacheProductShopping');
    localStorage.removeItem('cacheItemInformation');
  }

  static clearCacheGlassInfo() {
    localStorage.removeItem('cacheGlassInfo');
  }

  static clearCacheVilaxInfo() {
    localStorage.removeItem('cacheVilaxInfo');
  }

  static clearCacheDVHInfo() {
    localStorage.removeItem('cacheDVHInfo');
  }

  static clearCachePrefaReglasInfo() {
    localStorage.removeItem('cachePrefaReglasInfo');
  }

  static clearCachePrefaSinReglasInfo() {
    localStorage.removeItem('cachePrefaSinReglasInfo');
  }

  static clearCacheConfirmUser() {
    localStorage.removeItem('user-confirmation');
  }

  static clearCacheSelectedAddress() {
    localStorage.removeItem('cacheSelectedAddress');
  }
  static clearCacheChangePassword() {
    localStorage.removeItem('change-password');
  }
  static clearCacheSelectedFamily() {
    localStorage.removeItem('cacheSelectedFamily');
  }
  static clearCacheSelectedCurrency() {
    localStorage.removeItem('cacheSelectedCurrency');
  }
  static clearCacheSelectedClient() {
      localStorage.removeItem('cacheSelectedClient');
  }
  static clearCacheSelectedProject() {
    localStorage.removeItem('cacheSelectedProject');
  }
  static clearCacheProductShopping() {
    localStorage.removeItem('cacheProductShopping');
  }
  static clearCacheItemInformation() {
    localStorage.removeItem('cacheItemInformation');
  }
  //#endregion clean Storage
  /************************LIMPIEZA DEL CACHE*********************/

  /************************CREACION DEL CACHE*********************/
  //#region Create Storage
  static createCacheUser(dataUsuario: UserModel) {
    localStorage.setItem('cacheUser', JSON.stringify(dataUsuario));
  }

  static createCacheGlassInfo(data) {
    localStorage.setItem('glassInfo', JSON.stringify(data));
  }

  static createCacheVilaxInfo(data) {
    localStorage.setItem('VilaxInfo', JSON.stringify(data));
  }

  static createCacheDVHInfo(data) {
    localStorage.setItem('DVHInfo', JSON.stringify(data));
  }

  static createCachePrefaReglasInfo(data) {
    localStorage.setItem('PrefaReglasInfo', JSON.stringify(data));
  }
  static createCachePrefaSinReglasInfo(data) {
    localStorage.setItem('PrefaSinReglasInfo', JSON.stringify(data));
  }

  static createCacheAuthorization(access_token: any) {
    const infoUser = {
      token: access_token,
    };
    localStorage.setItem('authorizationClient', JSON.stringify(infoUser));
  }

  static createCacheConfirmUser(userData) {
    localStorage.setItem('user-confirmation', userData);
  }

  static createCacheChangePassword(userData) {
    localStorage.setItem('change-password', userData);
  }

  static createCacheSelectedAddress(data) {
    localStorage.setItem('cacheSelectedAddress', JSON.stringify(data));
  }
  static createCacheSelectedFamily(data) {
    localStorage.setItem('cacheSelectedFamily', JSON.stringify(data));
  }
  static createCacheSelectedCurrency(data) {
    localStorage.setItem('cacheSelectedCurrency', JSON.stringify(data));
  }
  static createCacheSelectedClient(data) {
    localStorage.setItem('cacheSelectedClient', JSON.stringify(data));
  }
  static createCacheSelectedProject(data) {
    localStorage.setItem('cacheSelectedProject', JSON.stringify(data));
  }
  static createCacheProductShopping(data) {
    localStorage.setItem('cacheProductShopping', JSON.stringify(data));
  }
  static createCacheItemInformation(data) {
    localStorage.setItem('cacheItemInformation', JSON.stringify(data));
  }
  //#endregion Create Storage
  /******************************CREACION DEL CACHE**************************/

  /************************OBTENER INFORMACION DEL CACHE*********************/
  //#region Get Storage
  static getCacheUser() {
    const infoUser = localStorage.getItem('cacheUser');
    const objectUser = JSON.parse(infoUser);
    return objectUser;
  }

  static getCacheGlassInfo() {
    const infoGlassService = localStorage.getItem('glassInfo');
    const objectGlassInfo = JSON.parse(infoGlassService);
    return objectGlassInfo;
  }

  static getCacheVilaxInfo() {
    const infoVilaxService = localStorage.getItem('VilaxInfo');
    const objectVilaxInfo = JSON.parse(infoVilaxService);
    return objectVilaxInfo;
  }

  static getCacheDVHInfo() {
    const infoDVHService = localStorage.getItem('DVHInfo');
    const objectDVHInfo = JSON.parse(infoDVHService);
    return objectDVHInfo;
  }

  static getCachePrefaRelgasInfo() {
    const infoPrefaService = localStorage.getItem('PrefaReglasInfo');
    const objectPrefaInfo = JSON.parse(infoPrefaService);
    return objectPrefaInfo;
  }

  static getCachePrefaSinReglasInfo() {
    const infoPrefaService = localStorage.getItem('PrefaSinReglasInfo');
    const objectPrefaInfo = JSON.parse(infoPrefaService);
    return objectPrefaInfo;
  }

  static getCacheSelectedAddress() {
    const info = localStorage.getItem('cacheSelectedAddress');
    const data = JSON.parse(info);
    return data;
  }

  static getCacheAuthorization() {
    const info = localStorage.getItem('authorizationClient');
    const objectPass = JSON.parse(info);
    return objectPass;
  }
  static getCacheConfirmUser() {
    const info = localStorage.getItem('user-confirmation');
    return info;
  }
  static getCacheChangePassword() {
    const info = localStorage.getItem('change-password');
    return info;
  }
  static getCacheSelectedFamily() {
    const info = localStorage.getItem('cacheSelectedFamily');
    const data = JSON.parse(info);
    return data;
  }
  static getCacheSelectedCurrency() {
    let data;
    const info = localStorage.getItem('cacheSelectedCurrency');
    if (info !== null) {
      data = JSON.parse(info);
    } else {
      data = '';
    }
    return data;
  }
  static getCacheSelectedClient() {
    let data;
    const info = localStorage.getItem('cacheSelectedClient');
    if (info !== null) {
      data = JSON.parse(info);
    } else {
      data = '';
    }
    return data;
  }
  static getCacheSelectedProject() {
    let data;
    const info = localStorage.getItem('cacheSelectedProject');
    if (info !== null) {
      data = JSON.parse(info);
    } else {
      data = '';
    }
    return data;
  }

  static getCacheProductShopping () {
    let data;
    const info = localStorage.getItem('cacheProductShopping');

    if (info !== null) {
      data = JSON.parse(info);
    } else {
      data = ''
    }

    return data;
  }

  static getCacheItemInformation () {
    let data;
    const info = localStorage.getItem('cacheItemInformation');

    if (info !== null) {
      data = JSON.parse(info);
    } else {
      data = ''
    }

    return data;
  }
  //#endregion Get Storage
  /************************OBTENER INFORMACION DEL CACHE*********************/

  /************************CREACION DEL CACHE*********************/
  //#region Create Storage
  static createCacheSelectedCustomer(dataCustomer: CutsProjectModel) {
    localStorage.setItem('cacheCustomer', JSON.stringify(dataCustomer));
  }
  //#endregion Create Storage
  /******************************CREACION DEL CACHE**************************/

  /************************OBTENER INFORMACION DEL CACHE*********************/
  //#region Get Storage
  static getCacheSelectedCustomer() {
    const infoCustomer = localStorage.getItem('cacheCustomer');
    const objectCustomer = JSON.parse(infoCustomer);
    return objectCustomer;
  }
  //#endregion Get Storage
  /************************OBTENER INFORMACION DEL CACHE*********************/
}
